<!-- 單筆待繳款項 -->
<template>
  <v-client-table
    v-if="isShow"
    name="pendingPayment"
    :data="tableData"
    :columns="tableColumns"
    :options="tableOptions"
  >
    <template #resend="props">
      <button
        v-if="props.row.resend"
        class="btn"
        :class="$style.link"
        @click="handleResendPaymentInfo(props.row.resend)"
      >
        代碼重新寄送
      </button>
    </template>
  </v-client-table>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    currentTab: {
      type: String,
      default: '',
    },
    memberAreaData: {
      type: Array,
      default: () => [],
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    tableColumns: {
      type: Array,
      default: () => [],
    },
    tableOptions: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    isShow() {
      return this.currentTab === 'pendingPayment' && this.memberAreaData;
    },
  },
  methods: {
    async handleResendPaymentInfo(id) {
      const result = await this.resendPaymentInfo(id);
      if(result) {
        alert('已寄發代碼，請稍候！若未收到郵件，請至您的垃圾郵件夾查詢。');
      }
    },
    ...mapActions('member', [
      'resendPaymentInfo',
    ]),
  },
};
</script>

<style lang="scss" module>
.link {
  color: $red;
}
</style>
